// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2vvZd","file":"styles_file__1uyxi"};